export default __webpack_public_path__ + "static/media/RUS.b4132869.svg";